import styled from "@emotion/styled"
import { spacingFluidMd } from "@porsche-design-system/components-react/emotion"
import { Flex, Skeleton } from "src/components"

export const ConditionAndServiceSkeleton = () => (
	<Flex $gap="xl">
		<HalfWidth>
			<Skeleton.List entries={3} withHeader />
			<Skeleton.List entries={3} withHeader />
			<Skeleton.List entries={5} withHeader />
		</HalfWidth>
		<HalfWidth>
			<Skeleton.List entries={9} withHeader />
		</HalfWidth>
	</Flex>
)

const HalfWidth = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingFluidMd};
	width: 50%;
`
